<template>
  <div>
    <!--TODO: speed of particpant swaping isnt amazing, when everything is together, maybe revist and try events and local data -->
    <all-videos
      v-if="mode==0 || mode == 4"
    />
    <select-videos
      v-if="mode==1"
    />
    <speaker-videos
      v-if="mode==2"
    />
    <no-videos
      v-if="mode==3"
      :participants="$parent.$refs.sideBar.$refs.sidePart.participants"
    />
  </div>
</template>
<script>
import { ref, watch, onBeforeUnmount } from "@vue/composition-api"
import NoVideos from './VideoArea/NoVideos'
import AllVideos from './VideoArea/AllVideos'
import SelectVideos from './VideoArea/SelectVideos'
import SpeakerVideos from './VideoArea/SpeakerVideos'
export default {
  name: 'VideoArea',
  components: {
    'no-videos': NoVideos,
    'all-videos': AllVideos,
    'select-videos': SelectVideos,
    'speaker-videos': SpeakerVideos
  },
  props: {
    mode: {
      type: Number,
      default: 0
    },
    streams: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    const speaker_userId = ref('')
    const speakerList = ref([])
    const updater = ref({})
    const activeVideos = ref(0)
    const videoComponents = ref([])
    const packetLost = ref(
      {
        switchInterval: 120000,
        retrySwitchInterval: 600000,
        detectInterval: 30000,
        maxPacketLost: 2,
        packetLostDetected: null,
        lastPacketLostCheck: null,
      }
    )

    calcVideoComp(context.parent.$refs.sideBar.$refs.sidePart.participants)

    watch(() => context.parent.$refs.sideBar.$refs.sidePart.participants, (newParticipants, oldValue) => {
      calcVideoComp(newParticipants)
    })

    const actTime = ref(null)
    packetLost.value.lastPacketLostCheck = new Date().getTime()
    updater.value = setInterval(onTimer, 1000)
    if(context.parent.getItem('switchInterval') !== undefined) {
      packetLost.value.switchInterval = context.parent.getItem('switchInterval')
      packetLost.value.retrySwitchInterval = packetLost.value.switchInterval * 5
    }
    if(context.parent.getItem('detectInterval') !== undefined) {
      packetLost.value.detectInterval = context.parent.getItem('detectInterval')
    }
    if(context.parent.getItem('maxPacketLost') !== undefined) {
      packetLost.value.maxPacketLost = context.parent.getItem('maxPacketLost')
    }

    onBeforeUnmount(() => {
      clearInterval(updater.value)
    })

    function messageHandler (e) {
      console.log('receiver speaker ssrc: ' + e)
      speaker_userId.value = e
      let index = speakerList.value.findIndex( speaker => speaker == speaker_userId.value)
      if (index < 0) {
        speakerList.value.unshift(speaker_userId.value)
        if (speakerList.value.length > 3) {
          speakerList.value.pop()
        }
      } else if (index > 0){
        speakerList.value.splice(0, 0, speakerList.value.splice(index, 1)[0])
      }
      console.log('receiver speaker list: ' + speakerList.value)
    }

    function onTimer() {
      checkActiveStreams()
      if (context.parent.$refs.meetingControls) {
        context.parent.sendAudioLevel()
      }
      isVerticalVideo()
    }

    function isVerticalVideo() {
        if (activeVideos) {
            var videos = document.getElementsByTagName('video');
            for (var i = 0; i < videos.length; i++) {
                var el = videos[i];
                if (props.streams[i] && props.streams[i].active && props.streams[i].loaded) {
                  var isVertical = el && (el.videoHeight/el.videoWidth) > 1;
                  el.style['object-fit'] = isVertical ? 'contain' : 'cover';
                }
            }
        }
    }

    async function checkActiveStreams(){
      actTime.value = new Date().getTime()
      await asyncForEach(props.streams, async (stream) => {
        await isActiveStream(stream).catch(e => console.log(e))
      }).catch(e => console.log(e))
      let filtered = props.streams.filter( value => value.active == true )
      if (activeVideos.value != filtered.length) {
        activeVideos.value = filtered.length
      }
      if(context.parent.$refs.meetingControls.desktop){
        activeVideos.value++;
      }
      if ((actTime.value - packetLost.value.lastPacketLostCheck) >= packetLost.value.detectInterval && activeVideos.value > 0) {
        packetLost.value.lastPacketLostCheck = new Date().getTime()
        packetLostDetection()
      }
    }

    async function asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array).catch(e => console.log(e))
      }
    }

    async function isActiveStream(stream) {
      if (stream.media.getVideoTracks().length > 0 && stream.media.getVideoTracks()[0] != null) {
        let result = await context.parent.session.connection.getStats(stream.media.getVideoTracks()[0]).catch(e => console.log(e))
        result.forEach(report => {
          if( report.type === 'inbound-rtp') {
            if (report.bytesReceived > stream.bytesRecv) {
              stream.active = true
              if ((actTime.value - packetLost.value.lastPacketLostCheck) >= packetLost.value.detectInterval) {
                if (report.packetsReceived > stream.packetsRecv) {
                  stream.packetsLostPerc = ((report.packetsLost - stream.packetsLost) / (report.packetsReceived - stream.packetsRecv)) * 100
                } else {
                  stream.packetsLostPerc = (report.packetsLost / report.packetsReceived) * 100
                }
                console.log(stream.packetsLostPerc + " % for: " + report.ssrc)
              }
            } else {
              stream.clicked = false
              stream.active = false
            }
            stream.packetsLost = report.packetsLost
            stream.packetsRecv = report.packetsReceived
            stream.bytesRecv = report.bytesReceived
            stream.ssrc = report.ssrc
          }
        })
      }
    }

    function packetLostDetection() {
      if (packetLost.value.packetLostDetected == null) {
        let noPacketLost = props.streams.filter( value => value.active == true && value.packetsLostPerc < packetLost.value.maxPacketLost )
        if (noPacketLost.length == 0 && activeVideos.value > 1) {
          console.log("packet lost detected switch to limited")
          if (props.mode < 3) {
            context.parent.$refs.meetingControls.changeVideoLayoutOption(4)
          }
          packetLost.value.packetLostDetected = new Date().getTime()
        }
      } else if ((new Date().getTime() - packetLost.value.packetLostDetected) >= packetLost.value.switchInterval) {
        console.log("switch back to normal")
        if (props.mode > 2) {
          context.parent.$refs.meetingControls.changeVideoLayoutOption(0)
        }
        packetLost.value.switchInterval = packetLost.value.retrySwitchInterval //600000
        packetLost.value.packetLostDetected = null
      }
    }

    function calcVideoComp(newParticipants) {
      if (videoComponents.value.length > 0) {
        videoComponents.value.forEach( videoComponent => {
          let index = newParticipants.findIndex((part) => { return part.id == videoComponent.user.id })
          if (index < 0) {
            videoComponents.value.splice(videoComponents.value.indexOf(videoComponent), 1)
          }
        })

        newParticipants.forEach( participant => {
          let index = videoComponents.value.findIndex((videoComponent) => {
            return videoComponent.user.id == participant.id
          })
          let streams = props.streams
          streams.forEach( (item,i) => {
            if(item.source === "desktop"){
              streams.splice(i, 1);
              streams.unshift(item)
            }
          })
          let foundMedia = streams.filter((media) => {
            return media.user.id == participant.id && media.active
          })
          if (index < 0) {
            videoComponents.value.push({user: participant, clicked: false, media: foundMedia})
          } else {
            videoComponents.value[index].user = participant
            if (foundMedia.length != videoComponents.value[index].media.length)
              videoComponents.value[index].media = foundMedia
          }
        })
      } else {
         newParticipants.forEach((participant) => {
          let foundMedia = props.streams.filter((media) => {
            return media.user.id == participant.id
          })
          videoComponents.value.push({user: participant, clicked: false, media: foundMedia})
        })
      }
    }

    function getActiveMedia(media) {
      return media.filter( (cam) => cam.active == true)
    }

    function computeVideoElementStyle(index) {
      if (index == 0) {
        return {width: '100%', height: '100%'}
      } else if(index == 1) {
        return {top: '80%', left: '80%', width: '20%', height: '20%'}
      } else if(index == 2) {
        return {top: '80%', left: '60%', width: '20%', height: '20%'}
      } else if(index == 3) {
        return {top: '80%', left: '40%', width: '20%', height: '20%'}
      }
    }

    function moveToFirst(data, el) {
      data.forEach( (item,i) => {
        if(item === el){
          data.splice(i, 1);
          data.unshift(item)
        }
      })
    }

    return {
      updater,
      videoComponents,
      activeVideos,
      speaker_userId,
      speakerList,
      messageHandler,
      packetLost,
      packetLostDetection,
      checkActiveStreams,
      actTime,
      getActiveMedia,
      calcVideoComp,
      computeVideoElementStyle,
      moveToFirst
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/VideoArea.vue